
import { Component, Prop } from 'vue-property-decorator';
import ModalView from '@/components/helper/modal-view.vue';
import Util from '@/lib/util';
import ListBase from '@/lib/listbase';

@Component({
    components: { ModalView },
    watch: {
        value: function (val) {
            let obj = (this as any);
            obj.modalShow = val;
            if (val) {
                obj.initForm();
            }
        },
        modalShow: function (val) {
            if (!val) {
                this.$emit('input', false);
            }
        }
    }
})

export default class ImportChangesView extends ListBase {
    @Prop({ type: Boolean, default: false }) value: boolean;
    file: any = null;
    modalSetting: any = {
        entity: "sale",
        width: "95%",
        showForm: false,
        titleFull: 'Importar Listado',
        icon: 'mdi-upload',
        saveText: 'Actualizar CEM',
        saveIcon: 'mdi-upload',
        disabledSave: true,
        customSave: true,
        //showFootActions: false,
        persistent: false
    };

    get columns() {
        let cols = [
            { value: 'number', text: 'Id', type: 'text', sortable: false },
            { value: 'plate', text: 'Placa', type: 'text', sortable: false },
            { value: 'vin', text: 'Chasis', type: 'text', sortable: false },
            { value: 'manufacturer_name', text: 'Marca', type: 'text', sortable: false },
            { value: 'model', text: 'Modelo', type: 'text', sortable: false },
            { value: 'city', text: 'Ciudad', type: 'text', sortable: false },
            { value: 'dealer_name', text: 'Concesionario', type: 'text', sortable: false },
            { value: 'ot', text: 'OT', type: 'text', sortable: false },
            { value: 'km', text: 'Ultimo kilometraje', type: 'text', sortable: false },
            { value: 'customer', text: 'Nombre de Cliente', type: 'text', sortable: false },
            { value: 'document', text: 'DNI', type: 'text', sortable: false },
            { value: 'cellphone', text: 'Movil', type: 'text', sortable: false },
            { value: 'email', text: 'Email', type: 'text', sortable: false },
            { value: 'service_date', text: 'Fecha de Servcio', type: 'text', sortable: false },
            { value: 'year', text: 'Anio', type: 'text', sortable: false },
            { value: 'month', text: 'Mes', type: 'text', sortable: false },
            { value: 'assessor_name', text: 'Asesor de Servicio', type: 'text', sortable: false },
            { value: 'technician_name', text: 'Tecnico', type: 'text', sortable: false },
            { value: 'service_type', text: 'Tipo Trabajo', type: 'text', sortable: false },
            { value: 'payer', text: 'Pagador', type: 'text', sortable: false },
            { value: 'total', text: 'Facturacion', type: 'text', sortable: false },
        ];

        return cols;
    }

    get disabled() {
        if (this.file == null) return true;
        else return false
    }
    get loading() {
        return this.$store.state.sale.loading;
    }
    get list() {
        return this.$store.state.sale.reportList;
    }
    get totalCount() {
        return this.list.length;
    }
    get process() {
        return Util.abp.list.getItem(this.$store.state.sale.process);
    }

    initForm() {
        this.modalSetting.titleFull = "Importar " + this.process.name;
        this.modalSetting.saveText = "Actualizar " + this.process.name;
    }

    async importFile() {
        this.modalSetting.disabledSave = true;
        if (this.file == null) return;

        let formData = new FormData();
        formData.append('file', this.file);
        formData.append('process', this.process.id);

        let result = await this.$store.dispatch({
            type: 'sale/importData',
            data: formData
        });

        if (result) {
            if (this.totalCount > 0) {
                this.$toast.info('Primero Revise los datos Importados, <br/>Luego Presione "Actualizar" para completar el proceso', { timeout: 5000 });
                this.modalSetting.disabledSave = false;
            } else
                this.$toast.warning('No se detectaron cambios en los registros', { timeout: 3000 });
        }
    }

    async save() {
        if (this.totalCount > 0) {

            let newModel = await this.$store.dispatch({
                type: 'sale/updateBatch',
                data: {
                    items: this.list
                }
            });

            this.$toast.success('Registros Actualizados');
            this.$emit('save-success');
            this.cancel();

            return newModel;
        } else
            return false;
    }

    cancel() {
        this.file = null;
        this.$store.commit('sale/setReportList', []);
        this.$emit('input', false);
    }

    mounted() {
    }

    created() {
    }
}
